import React, { useEffect } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Footer } from "@/components/Footer";
import { LEGAL_DOCS, EFFECTIVE_DATE } from "./legalContent";

export default function Legal() {
  const { slug } = useParams();
  const doc = LEGAL_DOCS[slug];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!doc) return <Navigate to="/" replace />;

  return (
    <div className="bg-stylist-bg text-stylist-ink min-h-screen">
      <header className="border-b border-stylist-border bg-[#FAF8F5]/90 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-3xl mx-auto px-4 sm:px-8 h-20 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-home" className="flex items-center gap-3 group">
            <img src="/logo.png" alt="Senior Stylist logo" className="h-10 w-auto object-contain" />
            <span className="font-serif text-xl text-stylist-ink">Senior Stylist</span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-sm text-stylist-ink2 hover:text-stylist-ink ss-link-underline"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-8 py-14 md:py-20">
        <span className="eyebrow">Legal</span>
        <h1 className="mt-3 font-serif text-4xl sm:text-5xl text-stylist-ink" data-testid="legal-title">
          {doc.title}
        </h1>
        <p className="mt-3 text-xs font-mono uppercase tracking-widest text-stylist-muted">
          Effective {EFFECTIVE_DATE}
        </p>

        <p className="mt-8 text-[17px] leading-[1.8] text-stylist-ink2">{doc.intro}</p>

        <div className="mt-10 space-y-10">
          {doc.sections.map((s) => (
            <section key={s.heading}>
              <h2 className="font-serif text-2xl text-stylist-ink">{s.heading}</h2>
              <div className="mt-3 space-y-3">
                {s.body.map((p, i) => (
                  <p key={i} className="text-[15px] leading-[1.8] text-stylist-ink2">
                    {p}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-14 flex flex-wrap gap-4 pt-8 border-t border-stylist-border">
          {Object.values(LEGAL_DOCS)
            .filter((d) => d.slug !== slug)
            .map((d) => (
              <Link
                key={d.slug}
                to={`/legal/${d.slug}`}
                className="text-sm text-stylist-gold hover:text-stylist-ink ss-link-underline"
              >
                {d.title} →
              </Link>
            ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}
